import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { connect } from 'react-redux';
import LocalizedText from '@LocalizedText';
import { isMobileMode } from '@app/utils/utils';
import { closeWarning } from '@app/actions/popupsActions';

import Popup from '../Popup';
import './WarningPopup.scss';

const WarningPopup = ({ closeWarning, warning: { intlValues, active, titleLocKey, locKey, message, ...props }, mobileView }) =>
  active && (
    <Popup
      className={classnames('warning-popup', { mobile: mobileView })}
      titleLocKey={titleLocKey}
      closePopup={closeWarning}
      {...props}
    >
      {locKey ? <LocalizedText id={locKey} values={intlValues} tagName="div" /> : message ? message : 'Oops! Something went wrong.'}
    </Popup>
  );

WarningPopup.propTypes = {
  message: PropTypes.string,
  active: PropTypes.bool,
  titleLocKey: PropTypes.string,
  lLocKey: PropTypes.string,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
  closeWarning: PropTypes.func.isRequired,
};

export default connect(({ popups: { warning }, matrix: { ctx } }) => ({ warning, mobileView: isMobileMode(ctx) }), { closeWarning })(
  WarningPopup,
);
